import styled from "styled-components";

export const PricingStyles = styled.div`
    width: 100%;
    min-height: 600px;
    position: relative;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    padding: 0 0 50px;

    @media (min-width: 1200px) {
        padding: 0 0 70px;
    }

    .container {
        position: relative;
    }

    h1 {
        span {
            color: var(--primary);
        }
    }

    .pricing-holder {
        font-size: 14px;
        line-height: 18px;
        text-align: left;
        display: grid;
        gap: 15px;
        grid-template-columns: 1fr;

        @media (min-width: 768px) {
            grid-template-columns: repeat(2, 1fr);
        }

        @media (min-width: 992px) {
            grid-template-columns: repeat(3, 1fr);
        }

        .col {
            overflow: hidden;
            width: 100%;
            padding: 25px;
            border-radius: 28px;
            box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
            background: var(--white);
            cursor: pointer;

            &.proPlan {
                color: var(--white);
                background: #313131;

                .icon-box {
                    padding: 18px;
                    box-shadow: 0px 1.75px 28.88px 0px rgba(237, 146, 32, 0.4) inset;
                    background: rgba(255, 255, 255, 0.01);
                    border-radius: 20px;
                    img {
                        filter: invert(56%) sepia(80%) saturate(490%) hue-rotate(351deg) brightness(96%) contrast(93%);
                    }
                }

                .header {
                    color: var(--white);

                    &::after {
                        background: rgba(222, 222, 222, 1);
                    }
                }

                .list-wrap {
                    .li {
                        color: var(--white);
                    }
                }

                .title {
                    color: var(--white);
                }

                .price-box {
                    .price {
                        color: var(--white);
                    }
                    sup,
                    sub {
                        color: #949494;
                    }
                }

                .btn {
                    color: var(--white);
                    text-align: center;
                    background: var(--primary);
                }

                .info-list {
                    .text {
                        color: var(--white);
                    }
                }
            }

            .header {
                width: 100%;
                position: relative;
                padding: 0 0 5px;
                margin: 0 0 25px;
                color: #949494;

                &:after {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: -25px;
                    right: -25px;
                    height: 1px;
                    background: #dedede;
                }

                p {
                    margin-bottom: 25px;
                }

                .tag {
                    width: 100px;
                    height: 26px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 0 0 10px 10px;
                    position: absolute;
                    top: -25px;
                    right: 5px;
                    text-align: center;
                    font-size: 13px;
                    line-height: 16px;
                    text-transform: capitalize;
                    background: var(--primary);
                    color: var(--white);
                }
            }

            .btn {
                width: 100%;
                min-width: 100%;
                font-size: 15px;
                line-height: 18px;
                text-transform: capitalize;
                padding: 14px 10px;
                color: rgba(148, 148, 148, 1);
                border-radius: 10px;
                background: rgba(222, 222, 222, 1);
                box-shadow: 0px 2.81px 4.68px 0px #ffffff7a inset;
                border-radius: 48px;
                display: flex;
                justify-content: center;
            }
        }

        .list-wrap {
            .li {
                display: flex;
                align-items: center;
                gap: 10px;
                color: var(--text-color);
                font-size: 14px;
                line-height: 18px;
                font-weight: 400;
                text-transform: capitalize;
                margin-bottom: 15px;
            }
        }

        .icon-box {
            width: 65px;
            height: 65px;
            margin: 0 0 20px;
            padding: 18px;
            background: rgba(249, 249, 249, 1);
            border-radius: 20px;
            img {
                height: 30px;
            }
        }

        .title {
            display: block;
            font-size: 28px;
            line-height: 32px;
            font-weight: 400;
            text-transform: capitalize;
            color: var(--black);
            margin: 0 0 15px;
            text-align: left;
        }

        .price-box {
            width: 100%;
            margin: 0 0 20px;

            .price {
                display: inline-block;
                font-size: 46px;
                line-height: 50px;
                font-weight: 500;
                color: var(--text-color);
                padding: 0 3px;
            }

            sup,
            sub {
                display: inline-block;
                vertical-align: top;
                font-size: 12px;
                line-height: 15px;
                text-transform: capitalize;
            }
            sub {
                display: inline-block;
                vertical-align: bottom;
            }
        }

        .info-list {
            list-style: none;
            margin: 0;
            padding: 0;

            li {
                display: flex;
                align-items: center;
                gap: 10px;
                padding: 6px 0;
                .text {
                    color: var(--text-color);
                    text-decoration: underline;
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 300;
                    text-transform: capitalize;
                }
            }
        }
    }

    @keyframes floatUpDown {
        0% {
            transform: translateY(0);
        }
        50% {
            transform: translateY(-10px);
        }
        100% {
            transform: translateY(0);
        }
    }

    @keyframes floatDownUp {
        0% {
            transform: translateY(0);
        }
        50% {
            transform: translateY(10px);
        }
        100% {
            transform: translateY(0);
        }
    }

    .points_wrapper {
        overflow: hidden;
        width: 100%;
        height: 95vh;
        pointer-events: none;
        position: absolute;
        inset: 0;
        z-index: 1;
    }

    .points_wrapper .point {
        bottom: -10px;
        position: absolute;
        animation: floating-points infinite ease-in-out;
        pointer-events: none;
        width: 10px;
        height: 10px;
        background: linear-gradient(180deg, #1edce3 0%, #2783ec 100%);
        border-radius: 9999px;
    }
    @keyframes floating-points {
        0% {
            transform: translateY(0);
        }
        85% {
            opacity: 0;
        }
        100% {
            transform: translateY(-300px);
            opacity: 0;
        }
    }
    .points_wrapper .point:nth-child(1) {
        left: 10%;
        opacity: 1;
        animation-duration: 2.35s;
        animation-delay: 0.2s;
    }
    .points_wrapper .point:nth-child(2) {
        left: 30%;
        opacity: 0.7;
        animation-duration: 2.5s;
        animation-delay: 0.5s;
    }
    .points_wrapper .point:nth-child(3) {
        left: 25%;
        opacity: 0.8;
        animation-duration: 2.2s;
        animation-delay: 0.1s;
    }
    .points_wrapper .point:nth-child(4) {
        left: 44%;
        opacity: 0.6;
        animation-duration: 2.05s;
    }
    .points_wrapper .point:nth-child(5) {
        left: 50%;
        opacity: 1;
        animation-duration: 1.9s;
    }
    .points_wrapper .point:nth-child(6) {
        left: 75%;
        opacity: 0.5;
        animation-duration: 1.5s;
        animation-delay: 1.5s;
    }
    .points_wrapper .point:nth-child(7) {
        left: 88%;
        opacity: 0.9;
        animation-duration: 2.2s;
        animation-delay: 0.2s;
    }
    .points_wrapper .point:nth-child(8) {
        left: 58%;
        opacity: 0.8;
        animation-duration: 2.25s;
        animation-delay: 0.2s;
    }
    .points_wrapper .point:nth-child(9) {
        left: 98%;
        opacity: 0.6;
        animation-duration: 2.6s;
        animation-delay: 0.1s;
    }
    .points_wrapper .point:nth-child(10) {
        left: 65%;
        opacity: 1;
        animation-duration: 2.5s;
        animation-delay: 0.2s;
    }
`;
